import React, { useState, useEffect, memo, useRef } from 'react'
import ReactDOM from 'react-dom'
import * as d3 from 'd3'
import moment from 'moment'
import { Col, Row } from 'antd'
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons'
import '../../../css/graph.scss'
import { CHART_COLORS } from '../../../util/chartPalette'
const Graph = (props) => {
  var margin = { top: 10, right: 5, bottom: 80, left: 35 }
  var graphWidth = props.width || 400
  var width = graphWidth - 100
  var height = 300

  // append the svg object to the body of the page
  var svg

  const [minp, setMinp] = useState(
    props.data.data[0]?.values?.length - 50 || 50
  ) //Last page
  const [maxp, setMaxp] = useState(
    props.data.data[0]?.values?.length + 51 || 50
  )

  useEffect(() => {
    if (
      d3
        .select('#' + props.identifier)
        .selectAll('svg')
        .empty()
    ) {
      svg = d3
        .select('#' + props.identifier)
        .append('svg')
        .attr('stroke', 'black')
        .style('stroke-width', '0.8px')
        .attr('width', graphWidth + 'px')
        .attr('height', '390px')
      //   .attr("width", 40+width + margin.left + margin.right)
      // .attr("height", height + margin.top + margin.bottom)
    } else {
      svg = d3.select('#' + props.identifier).select('svg')
    }

    svg.selectAll('g > *').remove()
    svg.selectAll('path').remove()

    svg = svg
      .append('g')
      .attr(
        'transform',
        'translate(' + (margin.left + 10) + ',' + margin.top + ')'
      )
    if (props.data.data[0]) chart(props.data)
  }, [minp, maxp, props.data])

  function chart(dataReady) {
    var k = dataReady.data.map((d) => {
      return {
        ...d,
        values: d.values.filter(
          (t, i) => t.y != null && t.y.length != 0 && i >= minp && i < maxp
        ),
      }
    })

    var formattedData = k.map((d) => {
      var isRed = false
      return {
        ...d,
        values: d.values.map((i) => {
          var l = 0

          // var valuey = (i.y.reduce((a,c)=>a+c, l))/i.y.length
          var valuey = i.y[0] != undefined ? i.y[i.y.length - 1] : 0
          if (i.y > d.threshold.max || i.y < d.threshold.min) isRed = true
          return { x: i.x, y: valuey, z: i.y }
        }),
        isRed: isRed,
      }
    })

    var xAxisData = dataReady.data[0].values
      .filter((d, i) => {
        return i >= minp && i < maxp
      })
      .map(function (d) {
        return d.x
      }) //

    var allLines = dataReady.data.map((i) => i.reading)

    var myColor = d3
      .scaleOrdinal()
      .domain(
        dataReady.data.map((i) => {
          return i.reading
        })
      )
      .range([CHART_COLORS.lineBlue, ...d3.schemeSet2])
    // Add X axis --> it is a date format

    var x = d3.scalePoint().domain(xAxisData).range([0, width]).padding(0.2)
    svg
      .append('g')
      .attr('transform', 'translate(4,' + (height + 3) + ')')
      .call(d3.axisBottom(x).ticks(10))
      .selectAll('text')
      .style('text-anchor', 'end')
      .attr('dx', '-.8em')
      .attr('dy', '.15em')
      .attr('transform', 'rotate(-45)')
      .style('font-size', '10px')

    // Add Y axis
    var y = d3
      .scaleLinear()
      .domain([
        dataReady.yAxisRange.min > 10
          ? dataReady.yAxisRange.min - 10
          : dataReady.yAxisRange.min,
        dataReady.yAxisRange.max,
      ])
      .range([height, 0])
    svg
      .append('g')
      .call(d3.axisLeft(y).ticks(5))
      .attr('transform', 'translate(4,' + 3 + ')')

    svg
      .append('text')
      .attr('class', 'y label')
      .attr('text-anchor', 'end')
      .attr('y', -11)
      .attr('x', 20)
      .attr('dy', '.75em')
      .text(props.data.yAxisLable)

    svg
      .append('text')
      .attr('class', 'y label')
      .attr('text-anchor', 'end')
      .attr('y', 56)
      .attr('x', width / 2 - 30 + margin.left)
      .attr('dy', '1em')
      .attr('transform', 'translate(0,' + height + ')')
      .attr('letter-spacing', 2)
      .attr('stroke', 'black')
      .text('Date')

    // Add the lines
    var line = d3
      .line()
      .x(function (d) {
        return x(d.x)
      })
      .y(function (d) {
        return y(d.y)
      })
      .curve(d3.curveMonotoneX)

    svg
      .selectAll('myLines')
      .data(formattedData)
      .enter()
      .append('path')
      .attr('transform', 'translate(0,0)')
      .attr('d', function (d) {
        return line(d.values)
      })
      .attr('stroke', function (d) {
        return myColor(d.reading)
      })
      .style('stroke-width', 2)
      .style('fill', 'none')

    var tooltip = d3
      .select('#' + props.identifier)
      .append('div')
      .attr('class', 'chartToolTip')
      .style('position', 'absolute')
      .style('z-index', '10')
      .style('visibility', 'hidden')
    // .text("a simple tooltip");

    // Add the points
    svg
      // First we need to enter in a group
      .selectAll('myDots')
      .data(formattedData)
      .enter()
      .append('g')
      .attr('transform', 'translate(5,0)')
      .style('fill', function (d) {
        return myColor(d.reading)
      })
      // Second we need to enter in the 'values' part of this group11
      .selectAll('myPoints')
      .data(function (d) {
        return d.values
      })
      .enter()
      .append('circle')
      .attr('cx', function (d) {
        return x(d.x)
      })
      .attr('cy', function (d) {
        return y(d.y)
      })
      .attr('r', 5)
      .attr('stroke', 'white')
      .on('mouseover', function (d, i) {
        //  let values = (d.z.reduce((a,c)=>a+c+",", ""))
        let values = d.z.join(',')
        tooltip.html(`<b>Values</b>:${values}<br><b>Date</b>:${d.x}`)
        var left = 50
        tooltip
          .style('visibility', 'visible')
          .style('top', d3.select(this).attr('cy') - 50 + 'px')
          .style('left', parseInt(d3.select(this).attr('cx')) + 6 + 'px')
      })
      .on('mouseout', (event) => tooltip.style('visibility', 'hidden'))

    formattedData.map((element, index) => {
      // console.log("AQWā",element)
      svg
        .selectAll('myDots')
        .data([element])
        .enter()
        .selectAll('myPoints')
        .data(function (d) {
          return d.values
        })
        .enter()
        .append('text')
        .text(function (d, i) {
          //  let values = (d.z.reduce((a,c)=>a+c+",", ""))
          let values = d.y
          return `${values}`
        })
        .attr('x', function (d, i, dw) {
          // return x(d.x)+(i==0  ? 19 :-5)
          return x(d.x) + (index > 0 ? -20 : 12)
        })
        // .attr("y", function(d,i) { return y(d.y)-5+(i%2==0 ?((y(d.y) < 10)? 25 : 0) :(y(d.y)+30 > 300)? 0 : 25) } )
        .attr('y', function (d, i) {
          return y(d.y) + 10
        })
        .attr('transform', function (d, i) {
          return `rotate(-45, ${x(d.x)}, ${y(d.y)})`
        })
        .style('font-size', '12px')
    })

    // Add one dot in the legend for each name.
    svg
      .selectAll('mydots')
      .data(allLines)
      .enter()
      .append('rect')
      .attr('width', 8)
      .attr('height', 8)
      .attr('x', 10)
      .attr('y', function (d, i) {
        return height - 20 - i * 12
      }) // 100 is where the first dot appears. 25 is the distance between dots
      .attr('r', 7)
      .style('fill', function (d) {
        return myColor(d)
      })
      .style('font-size', '12px')
    // Add one dot in the legend for each name.
    svg
      .selectAll('mylabels')
      .data(allLines)
      .enter()
      .append('text')
      .attr('x', 25)
      .attr('y', function (d, i) {
        return height - 14 - i * 12
      }) // 100 is where the first dot appears. 25 is the distance between dots
      .style('fill', function (d) {
        return myColor(d)
      })
      .text(function (d) {
        return d
      })
      .attr('text-anchor', 'left')
      .style('alignment-baseline', 'middle')
      .style('font-size', '12px')
  }

  return (
    <Row
      style={{
        display: 'flex',
        height: 'fit-content',
        width: '100%',
        position: 'relative',
        justifyContent: 'space-between',
        flexDirection: 'row',
      }}
    >
      <Col
        style={{
          fontWeight: 'bold',
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <h4>
          {props.data.devicename +
            ` (${props.data?.data ? props.data?.data?.map((i) => i.reading).join('/') : ''})`}
        </h4>
      </Col>
      <Col
        className={props.isrotate ? 'mobile-measurementgraph' : ''}
        key={props.identifier}
        style={{
          display: 'flex',
          position: 'relative',
          height: 'fit-content',
          width: '100%',
          justifyContent:
            props.data.data[0] && props.data.data[0]?.values?.length > 0
              ? 'left'
              : 'center',
        }}
      >
        {props.data.data[0] && props.data.data[0]?.values?.length > 0 ? (
          <div
            style={{ height: '400px', width: '100%' }}
            id={props.identifier}
          ></div>
        ) : (
          <h2 style={{ height: 100, marginTop: '15%' }}>Data not available</h2>
        )}
      </Col>
    </Row>
  )
}

export default Graph
